import {Container, VStack} from '@bpba/ui-components';
import React from 'react';
import { Banner } from '../../components/Banner';
import { MenuAdhesion } from '../../components/MenuAdhesion';
import { CDNICOMERCIOSAPP_BANNER } from '../../Constants';


type layoutProps = {
    children: React.ReactNode;
};

export const Layout = (props: layoutProps) => {
    return (
        <Container>
            <VStack padding={['1rem', '0rem']}>
            <Banner borderRadius={['0px', '8px']} url={CDNICOMERCIOSAPP_BANNER} />
            <MenuAdhesion/>
            {props.children}
            </VStack>
        </Container>
    );
};
